import { render, staticRenderFns } from "./Mock.vue?vue&type=template&id=3dea58d6&scoped=true"
import script from "./Mock.vue?vue&type=script&lang=ts"
export * from "./Mock.vue?vue&type=script&lang=ts"
import style0 from "./Mock.vue?vue&type=style&index=0&id=3dea58d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea58d6",
  null
  
)

export default component.exports